import React from 'react';
import Navbar from '../Components/Navbar/Navbar';
import Amenagementstitre from '../ComponentsAmenagements/Amenagementstitre/Amenagementstitre';
import ActualitesAme from '../ComponentsAmenagements/ActualitesAme/ActualitesAme';
import TousAme from '../ComponentsAmenagements/TousAme/TousAme';
import ButtonAme from '../ComponentsAmenagements/ButtonAme/ButtonAme';
import Contact from '../Components/Contact/Contact';
import Footer from '../Components/Footer/Footer';
import Footerbas from '../Components/Footerbas/Footerbas';
import QuickActions from '../Components/QuickActions/QuickActions';
import Publicites from '../Components/Publicites/Publicites';

function Amenagements() {
    return (
      <div>
       <Navbar/>  
       <div className="page-avec-pub">

        {/* CONTENU */}
        <div className="page-contenu">
       <Amenagementstitre/>
       <ActualitesAme/>
       <TousAme/>
       <ButtonAme/>
       <Contact/>
       </div>
        {/* SIDEBAR DROITE */}
        <div className="sidebar-right">

          <QuickActions />
          <Publicites />
          </div>
      </div>
       <Footer/>
       <Footerbas/>
      </div>
      
    );
  }
  
  export default Amenagements;
  